import { z } from 'zod'

import {
  ARTICLE_MAX_LENGTH,
  getSupplierArticlesError,
} from '@/utils/nomenclature/articles'
import { getBarcodeError, sanitizeBarcode } from '@/utils/nomenclature/barcode'

export const barcodeSchema = z
  .string()
  .transform(sanitizeBarcode)
  .superRefine((value, ctx) => {
    const message = getBarcodeError(value)
    if (message) ctx.addIssue({ code: z.ZodIssueCode.custom, message })
  })

export const articleSchema = z
  .string()
  .trim()
  .max(ARTICLE_MAX_LENGTH, `Не длиннее ${ARTICLE_MAX_LENGTH} символов`)

export const supplierArticlesSchema = z
  .array(z.string())
  .superRefine((values, ctx) => {
    const message = getSupplierArticlesError(values)
    if (message) ctx.addIssue({ code: z.ZodIssueCode.custom, message })
  })
